/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Presentation_Templates_Admin_TabInputs */



/**
* | output |
* | --- |
* | "Presentations" |
*
* @param {Presentation_Templates_Admin_TabInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const presentation_templates_admin_tab = /** @type {((inputs?: Presentation_Templates_Admin_TabInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Presentation_Templates_Admin_TabInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Präsentationen")
	return /** @type {LocalizedString} */ ("Presentations")
});